import oldCartServiceFactory from "@shared/services/cart";
import oldCartApiServiceFactory from "@shared/services/cart_api";
import oldCartApiCallbacksFactory from "@shared/services/cart_api_callbacks";
import oldCartProductServiceFactory from "@shared/services/cart_product";
import oldDiscountServiceFactory from "@shared/services/discount";
import type { CartType } from "@shared/types/Cart";
import CartStore from "@retailer/svelte/stores/CartStore";
import httpService from "@modern/services/angularjs_shims/http_service";
import qService from "@modern/services/angularjs_shims/q_service";
import flashFactory from "@shared/services/flash";
import trackingService from "@modern/services/angularjs_shims/tracking";
import oldRetailersServiceFactory from "@shared/services/retailers";
import retailerContext from "@modern/services/retailer_context";
import RProductLine from "@shared/services/product_line";

// this is a wrapper around the old angularjs cart
// we preserve the business logic but remove the need for angularjs
// by shimming every service that gets passed includes
// these shims can be used anywhere else just as easily
const service = function () {
  const C = window["C"];
  let context: CartType;
  let cartStore;
  let oldCartService, oldCartApiService, oldCartApiCallbacks;

  async function initialize() {
    setupOldServices();
    context = await oldCartService.load();
  }

  function setupOldServices() {
    const $rootScope = window["$rootScope"];
    const oldRetailersService = oldRetailersServiceFactory(
      $rootScope,
      httpService,
      qService,
      C,
      retailerContext,
    );
    const CartProductService = oldCartProductServiceFactory();
    const DiscountService = oldDiscountServiceFactory();
    const flashService = flashFactory();
    const oldRProductLineService = RProductLine(httpService);
    oldCartApiCallbacks = oldCartApiCallbacksFactory(
      $rootScope,
      CartProductService,
      C,
      DiscountService,
    );
    oldCartApiService = oldCartApiServiceFactory(
      $rootScope,
      httpService,
      qService,
      flashService,
      trackingService,
      oldCartApiCallbacks,
      oldRetailersService,
    );
    oldCartService = oldCartServiceFactory(
      $rootScope,
      trackingService,
      oldCartApiService,
      oldCartApiCallbacks,
      oldRProductLineService,
      flashService,
    );
  }

  function setStore(context: CartType) {
    CartStore.update((n: CartType) => (n = context));
  }

  function getContext() {
    return context;
  }

  function getCartService() {
    return oldCartService;
  }

  function getCartApiCallbacks() {
    return oldCartApiCallbacks;
  }

  window["angularInjector"] = {
    get: function (name) {
      if (name === "Cart") {
        return getCartService();
      } else if (name === "CartApiCallbacks") {
        return getCartApiCallbacks();
      }
    },
  };

  return {
    initialize: initialize,
    setStore: setStore,
    getCart: getContext,
    getCartService: getCartService,
    getCartApiCallbacks: getCartApiCallbacks,
  };
};

const cart = service();
export default cart;
